import { cn } from "@/shared/lib";

type RefreshBarProps = { active: boolean; className?: string };

// Данные блока перечитываются, на экране пока старые: тонкая бегущая полоса по верхнему
// краю. Родитель — `relative` карточка `rounded-xl`: полоса скруглена по её углам и не
// требует `overflow-hidden` у карточки (он обрезал бы прилипающие части содержимого).
export const RefreshBar = ({ active, className }: RefreshBarProps) => (
  <div
    data-slot="refresh-bar"
    aria-hidden="true"
    className={cn(
      "pointer-events-none absolute inset-x-0 top-0 h-0.5 overflow-hidden rounded-t-[11px] transition-opacity",
      active ? "opacity-100" : "opacity-0",
      className,
    )}
  >
    <span className="absolute inset-y-0 w-[35%] animate-slide bg-accent motion-reduce:animate-none" />
  </div>
);
